(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunglasses-information-dian"]) return;
  try {
    
  //get all role=tab elements as a variable
  var tabs = document.querySelectorAll('#tabbed-interface [role=tab]'); 

  //add click event to each tab to run the showTabPanel function 
  for (i = 0; i < tabs.length; i++) { tabs[i].addEventListener("click", showTabPanel); } 

  //runs when tab is clicked
  function showTabPanel(el) { 

    //get tabs again as a different variable
    var tabs2 = document.querySelectorAll('#tabbed-interface [role=tab]');  

    //reset all tabs to aria-selected=false and normal font weight
    for (i = 0; i < tabs2.length; i++) {tabs2[i].setAttribute('aria-selected','false');tabs2[i].setAttribute('style','border: none;');} 

    //set aria-selected=true for clicked tab
    el.target.setAttribute('aria-selected', 'true'); 

    //make clicked tab have underline
    el.target.setAttribute('style', 'border-bottom: 2px solid black;'); 

    //get the aria-controls value of the tab that was clicked
    var tabPanelToOpen = el.target.getAttribute('aria-controls'); 

    //get all tabpanels as a variable
    var tabPanels = document.querySelectorAll('#tabbed-interface [role=tabpanel]'); 

    //hide all tabpanels
    for (i = 0; i < tabPanels.length; i++) { tabPanels[i].style.display = "none"; } 

    //show tabpanel who's tab was clicked
    document.getElementById(tabPanelToOpen).style.display = "flex"; 
  }
  $('[role=tablist]').keydown(function(e) {
    if (e.keyCode==37) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault(); 
    }
    if (e.keyCode==38) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault();
    }
    if (e.keyCode==39) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
    if (e.keyCode==40) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunglasses-information-leo"]) return;
  try {
    
  //get all role=tab elements as a variable
  var tabs = document.querySelectorAll('#tabbed-interface [role=tab]'); 

  //add click event to each tab to run the showTabPanel function 
  for (i = 0; i < tabs.length; i++) { tabs[i].addEventListener("click", showTabPanel); } 

  //runs when tab is clicked
  function showTabPanel(el) { 

    //get tabs again as a different variable
    var tabs2 = document.querySelectorAll('#tabbed-interface [role=tab]');  

    //reset all tabs to aria-selected=false and normal font weight
    for (i = 0; i < tabs2.length; i++) {tabs2[i].setAttribute('aria-selected','false');tabs2[i].setAttribute('style','border: none;');} 

    //set aria-selected=true for clicked tab
    el.target.setAttribute('aria-selected', 'true'); 

    //make clicked tab have underline
    el.target.setAttribute('style', 'border-bottom: 2px solid black;'); 

    //get the aria-controls value of the tab that was clicked
    var tabPanelToOpen = el.target.getAttribute('aria-controls'); 

    //get all tabpanels as a variable
    var tabPanels = document.querySelectorAll('#tabbed-interface [role=tabpanel]'); 

    //hide all tabpanels
    for (i = 0; i < tabPanels.length; i++) { tabPanels[i].style.display = "none"; } 

    //show tabpanel who's tab was clicked
    document.getElementById(tabPanelToOpen).style.display = "flex"; 
  }
  $('[role=tablist]').keydown(function(e) {
    if (e.keyCode==37) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault(); 
    }
    if (e.keyCode==38) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault();
    }
    if (e.keyCode==39) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
    if (e.keyCode==40) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunglasses-information-maya"]) return;
  try {
    
  //get all role=tab elements as a variable
  var tabs = document.querySelectorAll('#tabbed-interface [role=tab]'); 

  //add click event to each tab to run the showTabPanel function 
  for (i = 0; i < tabs.length; i++) { tabs[i].addEventListener("click", showTabPanel); } 

  //runs when tab is clicked
  function showTabPanel(el) { 

    //get tabs again as a different variable
    var tabs2 = document.querySelectorAll('#tabbed-interface [role=tab]');  

    //reset all tabs to aria-selected=false and normal font weight
    for (i = 0; i < tabs2.length; i++) {tabs2[i].setAttribute('aria-selected','false');tabs2[i].setAttribute('style','border: none;');} 

    //set aria-selected=true for clicked tab
    el.target.setAttribute('aria-selected', 'true'); 

    //make clicked tab have underline
    el.target.setAttribute('style', 'border-bottom: 2px solid black;'); 

    //get the aria-controls value of the tab that was clicked
    var tabPanelToOpen = el.target.getAttribute('aria-controls'); 

    //get all tabpanels as a variable
    var tabPanels = document.querySelectorAll('#tabbed-interface [role=tabpanel]'); 

    //hide all tabpanels
    for (i = 0; i < tabPanels.length; i++) { tabPanels[i].style.display = "none"; } 

    //show tabpanel who's tab was clicked
    document.getElementById(tabPanelToOpen).style.display = "flex"; 
  }
  $('[role=tablist]').keydown(function(e) {
    if (e.keyCode==37) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault(); 
    }
    if (e.keyCode==38) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault();
    }
    if (e.keyCode==39) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
    if (e.keyCode==40) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunglasses-information-rachel"]) return;
  try {
    
  //get all role=tab elements as a variable
  var tabs = document.querySelectorAll('#tabbed-interface [role=tab]'); 

  //add click event to each tab to run the showTabPanel function 
  for (i = 0; i < tabs.length; i++) { tabs[i].addEventListener("click", showTabPanel); } 

  //runs when tab is clicked
  function showTabPanel(el) { 

    //get tabs again as a different variable
    var tabs2 = document.querySelectorAll('#tabbed-interface [role=tab]');  

    //reset all tabs to aria-selected=false and normal font weight
    for (i = 0; i < tabs2.length; i++) {tabs2[i].setAttribute('aria-selected','false');tabs2[i].setAttribute('style','border: none;');} 

    //set aria-selected=true for clicked tab
    el.target.setAttribute('aria-selected', 'true'); 

    //make clicked tab have underline
    el.target.setAttribute('style', 'border-bottom: 2px solid black;'); 

    //get the aria-controls value of the tab that was clicked
    var tabPanelToOpen = el.target.getAttribute('aria-controls'); 

    //get all tabpanels as a variable
    var tabPanels = document.querySelectorAll('#tabbed-interface [role=tabpanel]'); 

    //hide all tabpanels
    for (i = 0; i < tabPanels.length; i++) { tabPanels[i].style.display = "none"; } 

    //show tabpanel who's tab was clicked
    document.getElementById(tabPanelToOpen).style.display = "flex"; 
  }
  $('[role=tablist]').keydown(function(e) {
    if (e.keyCode==37) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault(); 
    }
    if (e.keyCode==38) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault();
    }
    if (e.keyCode==39) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
    if (e.keyCode==40) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunglasses-information"]) return;
  try {
    
  //get all role=tab elements as a variable
  var tabs = document.querySelectorAll('[role=tab]'); 

  //add click event to each tab to run the showTabPanel function 
  for (i = 0; i < tabs.length; i++) { tabs[i].addEventListener("click", showTabPanel); } 

  //runs when tab is clicked
  function showTabPanel(el) { 

    //get tabs again as a different variable
    var tabs2 = document.querySelectorAll('[role=tab]');  

    //reset all tabs to aria-selected=false and normal font weight
    for (i = 0; i < tabs2.length; i++) {tabs2[i].setAttribute('aria-selected','false');tabs2[i].setAttribute('style','border: none;');} 

    //set aria-selected=true for clicked tab
    el.target.setAttribute('aria-selected', 'true'); 

    //make clicked tab have underline
    el.target.setAttribute('style', 'border-bottom: 2px solid black;'); 

    //get the aria-controls value of the tab that was clicked
    var tabPanelToOpen = el.target.getAttribute('aria-controls'); 

    //get all tabpanels as a variable
    var tabPanels = document.querySelectorAll('[role=tabpanel]'); 

    //hide all tabpanels
    for (i = 0; i < tabPanels.length; i++) { tabPanels[i].style.display = "none"; } 

    //show tabpanel who's tab was clicked
    document.getElementById(tabPanelToOpen).style.display = "flex"; 
  }
  $('[role=tablist]').keydown(function(e) {
    if (e.keyCode==37) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault(); 
    }
    if (e.keyCode==38) {
      $("[aria-selected=true]").prev().click().focus();
      e.preventDefault();
    }
    if (e.keyCode==39) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
    if (e.keyCode==40) {
      $("[aria-selected=true]").next().click().focus();
      e.preventDefault();
    }
  });

  } catch(e) { console.error(e); }
})();

})();
